import Footer from "../components/Footer";
import Hero from "../components/Hero";
import MainPart from "../components/MainPart";
import Navbar from "../components/Navbar";
// import ReactPDF from '@react-pdf/renderer';
// import MyDocument from "../components/PDFRenderer";


function Experiments(){
    return(
        <>
            <Navbar/>
            <Hero
                cName="hero-content" 
                heroImg="https://static.igem.wiki/teams/4696/wiki/hhhero-fig5.jpg"
                title="Experiments"
            />

            {/* JEAN CARRY */}
            <div className="content-container">
                <div className="sidepanel">
                    <ul>
                        <a href="#1" className="a-sidepanel"><ul class="header">Our Experimental Protocols</ul></a>
                        
                    </ul>
                </div>
                <MainPart
                    section_id={1}
                    container_cName="main-paragraph-container"
                    heading="Our Experimental Protocols"
                    subheading_cName='hide'
                    paragraph={[
                        'Here are all the experimental protocols we used in our wet lab experiment.'
                        ,<br/>,<br/>,
                        <a href="https://static.igem.wiki/teams/4696/wiki/wetlabprotocol.pdf">Download our experimental protocols here!</a>
                        
                    ]}
                    img_cName="hide"
                />
            </div>

            <Footer/>
        </>
    )
}

export default Experiments;